//MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info-events - Start
import { memo } from 'react';
import { Row, Col } from 'react-bootstrap';
import { BzCard } from '../../components';


const NewsAnnouncements = ({ objActiveNewsData, handleNewsDetails }) => {


    return (
        <BzCard className='transparent-card bdr-btm cursor-pointer' onClick={() => handleNewsDetails(objActiveNewsData)}>
            <Row className='g-0'>
                <Col className='d-flex flex-column justify-content-start'>
                    <div className='font-medium font-size3 color-text'>{objActiveNewsData?.Heading}</div>
                    <div className='font-regular font-size1 color-subtext pt-2'>{`${objActiveNewsData?.Date.split(' ')[0]} ${objActiveNewsData?.Time}`}</div>
                </Col>
            </Row>
        </BzCard>
    );
};

export default memo(NewsAnnouncements);

//MAhesh S:26-10-23 :BT-107375 - Breeze - Scrip -info-events - End